

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import store from './store'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Meta from 'vue-meta'
import {browserMobile} from './common/js/util'





Vue.directive('transfer-dom', TransferDom)

Vue.use(VueRouter)

Vue.use(Meta)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
loading: require('@/common/image/default_image_normal.png'),
error: require('@/common/image/default_image_normal.png')
})


import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)

FastClick.attach(document.body)
Vue.config.productionTip = false


router.afterEach((to, from) => {




if(browserMobile().isPc){
if(to.name == 'joinIndex'){
window.open(window.location.origin+'/joinUs/index.html','_self')
}else if(to.name == 'joinForm'){
window.open(window.location.origin+'/joinUs/joinForm.html','_self')
}






























}













})

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js